import { Component, inject } from '@angular/core';
import { Location } from '@angular/common';
import { LayoutService } from '../layout.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.html',
})
export class HeaderComponent {
  protected layout = inject(LayoutService);
  private location = inject(Location);

  goBack(): void {
    this.location.back();
  }
}
